import {
  faqs,
  howItWorks,
  suiteImages,
  inventoryCardSuiteModal,
  VerizonLoungeLogeBoxContent,
  VerizonLoungeClubSeatContent,
  InventoryCard,
  verizonLoungeLogeBoxSuiteNames,
  verizonLoungeClubSeatSuiteNames,
  LuxurySuiteContent,
  luxurySuiteNames,
  StudioSuiteContent,
  logeBoxSuiteNames,
  studioSuiteNames,
  LogeBoxSuiteContent,
  LoftTableSuiteContent,
  loftTableSuiteNames,
  MLoungeContent,
  mLoungeSuiteNames,
  ClubSeatingSuiteContent,
  clubSeatingSuiteNames,
  CheckoutTerms,
} from "./helpers";
import { routes } from "@/global/routes";
import { inventoryTypeUIDs, vendorUUIDs } from "../../constants";
import { DefaultRegistrationTerms } from "../../default_terms_and_conditions";

import SeatMap3dPreview from "public/images/devils/devils_flex_3d_venue.png";

const faviconImage =
  "https://ss-leagues.s3.amazonaws.com/NHL/Prudential%20Center/prudential-center-logo.svg";
const logoImage =
  "https://ss-leagues.s3.amazonaws.com/NHL/Prudential%20Center/prudential-center-logo.png";
const bannerImage =
  "https://ss-leagues.s3.amazonaws.com/NHL/Prudential%20Center/prudential-center-banner.png";
const backgroundImage =
  "https://ss-leagues.s3.amazonaws.com/NHL/Prudential%20Center/prudential-center-background.jpg";

import type { TeamConfig } from "../types";

const config: TeamConfig = {
  teamSchema: "prudentialcenter_suites",
  browserTitle: "Prudential Center Suites",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  teamName: "Prudential Center",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-10215-devils-sec",
    mapId: "blockmap2d",
    suiteImages,
    hide3dViewFromSlider: ["LB10"],
    dynamicSeatMapStaticImages: [
      {
        category: "Events",
        staticSeatMapImage:
          "https://ss-leagues.s3.amazonaws.com/NHL/Prudential%20Center/Concerts.png",
      },
      {
        category: "Events",
        staticSeatMapImage:
          "https://ss-leagues.s3.amazonaws.com/NHL/Prudential%20Center/Premium%20Map%20-%20Center%20Stage%202025-26.png",
        eventCodes: ["EPC0410E", "EPC0501E", "EPC0418", "E270808E"],
      },
    ],
    customSeatMapStaticImageStyle: {
      width: "80%",
      display: "block",
      marginX: "auto",
    },
    hide3dViewFromSliderByCategory: ["Events"],
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.redeem,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
  },

  // disabled routes
  disabledRoutes: [],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: false,
  isCrowdHandlerEnabled: true,
  inventoryType: inventoryTypeUIDs.suiteLevelV2,

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: true,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,

    isCheckoutAdditionalDetailsEnabled: true,
    isPerksEnabled: true,
    invPreviewAccountGroup: ["0"],
    allowCheckoutFromPreview: true,
    hideAllUpcomingGames: true,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
    googleTagManagerId: "",
  },

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl: "",
    externalRedirectUrl: "",
  },

  refreshInventoryWhenEventClick: false,

  isSaveCardAllowed: false,

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/devils/",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",
  shouldUseInternalLogin: false,

  isBrainTreePaymentEnabled: false,

  // images
  images: {
    faviconImage,
    logoNameImage: "",
    giftCardStandalonePageImage: "",
    findGamesBannerImage: bannerImage,
    authBackgroundImage: backgroundImage,
    checkoutStatusPageImage: backgroundImage,
    seatMap3dPreviewImage: SeatMap3dPreview.src,
    logoImage: logoImage + "?width=128&height=66",
  },

  uiConfigs: {
    bannerImage: {
      title: "",
      isBackgroundBasedBanner: false,
    },

    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: true,
      standardEventCard: true,
    },

    hideFeaturedGames: true,

    bottomBar: {
      showGameSelectionProgress: true,
    },

    hidePackageBalanceOnCheckout: true,
    hideServiceFee: true,

    inventoryCardSettings: {
      isPBLineItemsVisible: true,
      seatCountLabel: "Tickets Included",
      pbLineItemsValue: 5,

      suiteLevelInventoryCard: {
        customButtons: [
          {
            id: 1,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <VerizonLoungeLogeBoxContent />,
              });
            },
            suiteNames: verizonLoungeLogeBoxSuiteNames,
          },
          {
            id: 2,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <VerizonLoungeClubSeatContent />,
              });
            },
            suiteNames: verizonLoungeClubSeatSuiteNames,
          },
          {
            id: 3,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <LuxurySuiteContent />,
              });
            },
            suiteNames: luxurySuiteNames,
          },
          {
            id: 4,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <StudioSuiteContent />,
              });
            },
            suiteNames: studioSuiteNames,
          },
          {
            id: 5,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <MLoungeContent />,
              });
            },
            suiteNames: mLoungeSuiteNames,
          },
          {
            id: 6,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <LogeBoxSuiteContent />,
              });
            },
            suiteNames: logeBoxSuiteNames,
          },
          {
            id: 7,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <LoftTableSuiteContent />,
              });
            },
            suiteNames: loftTableSuiteNames,
          },
          {
            id: 8,
            label: "More Info",
            onClick: () => {
              inventoryCardSuiteModal.getState().set({
                isOpen: true,
                title: "More Info",
                content: <ClubSeatingSuiteContent />,
              });
            },
            suiteNames: clubSeatingSuiteNames,
          },
        ],
        renderBody: [
          {
            id: 1,
            component: () => <InventoryCard />,
          },
        ],
      },

      inventorySuitePackageInfo: [
        {
          suiteId: "Section 23",
          FBPackageValue: "Included",
        },
        {
          suiteId: "Section 24",
          FBPackageValue: "Starter Package",
          overrideFBPackageValue: "Included",
          overrideEventCode: ["EPB0509E"],
        },
        {
          suiteId: "Section 25",
          FBPackageValue: "Starter Package",
          overrideFBPackageValue: "Included",
          overrideEventCode: ["EPB0509E"],
        },
        {
          suiteId: "Section 26",
          FBPackageValue: "Starter Package",
        },
        {
          suiteId: "Section 27",
          FBPackageValue: "Starter Package",
        },
        {
          suiteId: "Section 28",
          FBPackageValue: "Starter Package",
          overrideFBPackageValue: "Included",
          overrideEventCode: ["EPB0509E"],
        },
        {
          suiteId: "Section 29",
          FBPackageValue: "Starter Package",
        },
        {
          suiteId: "Section 30",
          FBPackageValue: "Starter Package",
        },
        {
          suiteId: "Suite 138 ",
          FBPackageValue: "Included",
          overrideFBPackageValue: "Starter Package",
          overrideEventCode: ["EPB0509E"],
        },
        {
          suiteId: "Suite 234 ",
          FBPackageValue: "Not Included",
        },
      ],
    },

    inventoryContainer: {
      getGridCellHeight: (arg) => (arg?.mdDown ? 260 : 180),
    },

    gameFiltersSettings: {
      hideSectionFilter: true,
      hideAccessibilityFilter: true,
    },

    checkoutPage: {
      checkoutForm: {
        optionalAdditionalDetailsCompanyName: true,
        optionalAdditionalDetailsCateringName: true,
        optionalAdditionalDetailsCateringEmail: true,
        optionalAdditionalDetailsCateringPhone: true,
        optionalAdditionalDetailsContractTitle: true,
        optionalAdditionalDetailsContractEmail: true,
        optionalAdditionalDetailsContractLastName: true,
        optionalAdditionalDetailsContractFirstName: true,
        optionalAdditionalDetailsDisclaimerFullName: true,
        optionalAdditionalDetailsContractPhoneNumber: true,

        sameAsContractSignerDefaultChecked: true,

        hideContractTitle: true,
        hideContractLastName: true,
        hideContractFirstName: true,
        hideCateringAndTicketContact: false,
      },
    },
  },

  colors: {
    primary: "#CE1126",
  },

  howItWorks: howItWorks,
  faqs: faqs,

  languages: {
    topNavMenuItems: null,
    checkoutTermsAndCondition: <CheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseSeats: {
      progressBarText: "Select 1 event to continue!",
      purchaseSeatTabTitle: "Choose Events",
      bottomBarEventsDescription: "Event",
      progressBarSuccessText:
        "You're good to go! Add more events or select Continue to view seating options.",
      chooseSeatsTabTitle: "Choose Suite",
      findGamesTitle: "Upcoming Events",
      allUpcomingEventsTitle: "All Upcoming Events",
      noSessionsAvailableDescription: "Try adjusting your filters.",
      noSessionsAvailable: "No events available",
      cancelCartEventLabel: "events",
      changeSeatsButtonLabel: "Edit Selection",
      suiteLanguageDisclaimer:
        "Photos are representative. Actual suite may differ.",
    },
    purchaseGiftCard: null,
    redeemGiftCard: null,
    opponentSelectorTitle: "Event",

    checkoutSuccessMessage: "Your purchase is complete!",
    checkoutSuccessDescription:
      "Your Prudential Center Suites confirmation was successful! A representative will be in touch shortly to follow up with any questions you may have.",

    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description: "",
          },
          sendNowTrue: {
            description: "",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description: "",
        },
        logout: {
          description: "",
        },
        success: {
          description: "",
        },
      },
    },

    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
